import gsap from "gsap";
import { observer } from "./shared";

const
section_3 = document.getElementById("section-3");

observer.observe(section_3);
